import { ColDef, ICellRendererParams } from '@ag-grid-community/core'
import ActionCellRenderer from './actionCellRenderer'

export type FtpProfileFormData = {
  name: string
  protocol: 'FTP' | 'SFTP'
  host: string
  port?: number
  username?: string
  password?: string
  directory?: string
  isEnable?: boolean
}

export const protocolOptions = [
  { label: 'SFTP', value: 'SFTP' },
  { label: 'FTP', value: 'FTP' },
]

export const ftpProfileFormFields = {
  FTP_PROFILE_NAME: { key: 'name', label: 'Profile Name' },
  FTP_PROFILE_PROTOCOL: { key: 'protocol', label: 'Protocol' },
  FTP_PROFILE_HOST: { key: 'host', label: 'Host' },
  FTP_PROFILE_PORT: { key: 'port', label: 'Port' },
  FTP_PROFILE_USERNAME: { key: 'username', label: 'Username' },
  FTP_PROFILE_PASSWORD: { key: 'password', label: 'Password' },
  FTP_PROFILE_DIRECTORY: { key: 'directory', label: 'Directory' },
  FTP_PROFILE_IS_ENABLE: { key: 'isEnable', label: 'Enabled' },
} as const

export const getColumns = (
  isEditor: boolean,
  getFtpProfileToDelete: (params: ICellRendererParams) => void,
) =>
  [
    {
      headerName: ftpProfileFormFields.FTP_PROFILE_NAME.label,
      field: ftpProfileFormFields.FTP_PROFILE_NAME.key,
      minWidth: 200,
    },
    {
      headerName: ftpProfileFormFields.FTP_PROFILE_PROTOCOL.label,
      field: ftpProfileFormFields.FTP_PROFILE_PROTOCOL.key,
      maxWidth: 120,
    },
    {
      headerName: ftpProfileFormFields.FTP_PROFILE_HOST.label,
      field: ftpProfileFormFields.FTP_PROFILE_HOST.key,
      minWidth: 180,
    },
    {
      headerName: ftpProfileFormFields.FTP_PROFILE_PORT.label,
      field: ftpProfileFormFields.FTP_PROFILE_PORT.key,
      maxWidth: 100,
    },
    {
      headerName: ftpProfileFormFields.FTP_PROFILE_DIRECTORY.label,
      field: ftpProfileFormFields.FTP_PROFILE_DIRECTORY.key,
      maxWidth: 150,
    },
    {
      headerName: ftpProfileFormFields.FTP_PROFILE_IS_ENABLE.label,
      field: ftpProfileFormFields.FTP_PROFILE_IS_ENABLE.key,
      maxWidth: 110,
      cellRenderer: (params: ICellRendererParams) =>
        params?.value ? 'Yes' : 'No',
    },
    {
      hide: !isEditor,
      headerName: 'Action',
      field: 'action',
      minWidth: 200,
      maxWidth: 220,
      cellRenderer: (params: ICellRendererParams) => (
        <ActionCellRenderer
          params={params}
          isEditor={isEditor}
          getFtpProfileToDelete={getFtpProfileToDelete}
        />
      ),
    },
  ] as ColDef[]
